import { render, staticRenderFns } from "./RelatedArticlesItem.vue?vue&type=template&id=2cbb7126&"
import script from "./RelatedArticlesItem.vue?vue&type=script&lang=js&"
export * from "./RelatedArticlesItem.vue?vue&type=script&lang=js&"
import style0 from "./RelatedArticlesItem.vue?vue&type=style&index=0&id=2cbb7126&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports